/**
 * Ablage der CSRF-Werte (§25.1).
 *
 * Bewusst **ausschließlich im Modulspeicher**: kein `localStorage`, kein `sessionStorage`, kein
 * Cookie. Nichts Sicherheitsrelevantes überlebt damit ein Neuladen der Seite — der Wert wird
 * danach über die Sitzungs- beziehungsweise Zustandsauskunft neu bezogen. Das entspricht §40.3,
 * das schon für die Stimmauswahl verlangt, dass nichts Vertrauliches dauerhaft im Browser liegt.
 *
 * **Getrennt je Bereich.** Administrator und Teilnehmer haben eigene Sitzungen und damit eigene
 * sitzungsgebundene CSRF-Werte (§24.1, §25.1). Ein gemeinsamer Speicher würde beim Wechsel
 * zwischen `/` und `/verwaltung` innerhalb desselben Tabs den jeweils anderen Wert überschreiben —
 * die folgende Anfrage scheiterte dann mit 403, ohne dass ein Angriff vorläge.
 */

export const BEREICHE = ['admin', 'teilnehmer'] as const;

export type Bereich = (typeof BEREICHE)[number];

const werte = new Map<Bereich, string>();

export function setzeCsrfWert(bereich: Bereich, wert: string): void {
  werte.set(bereich, wert);
}

export function leseCsrfWert(bereich: Bereich): string | undefined {
  return werte.get(bereich);
}

export function verwerfeCsrfWert(bereich: Bereich): void {
  werte.delete(bereich);
}
